import { isIOS } from './device-detection';

export async function enterFullScreen(element?: HTMLElement) {
  if (!element) return;

  try {
    // For iOS, we need to use the video element directly
    if (isIOS()) {
      const videoElement = element.querySelector('video') as HTMLVideoElement;
      if (videoElement) {
        // On iOS, we need to use webkitEnterFullscreen() on the video element
        if ((videoElement as any).webkitEnterFullscreen) {
          await (videoElement as any).webkitEnterFullscreen();
          return true;
        }
        // Fallback to standard fullscreen on video element
        if (videoElement.requestFullscreen) {
          await videoElement.requestFullscreen();
          return true;
        }
      }
    }

    // Standard fullscreen implementation for other platforms
    if (element.requestFullscreen) {
      await element.requestFullscreen();
    } else if ((element as any).webkitRequestFullscreen) {
      await (element as any).webkitRequestFullscreen();
    } else if ((element as any).msRequestFullscreen) {
      await (element as any).msRequestFullscreen();
    } else if ((element as any).mozRequestFullScreen) {
      await (element as any).mozRequestFullScreen();
    }
    return true;
  } catch (error) {
    console.error("Error entering fullscreen mode:", error);
    return false;
  }
}

export function exitFullScreen() {
  try {
    // For iOS, we need to exit fullscreen from the video element
    if (isIOS()) {
      const videoElement = document.querySelector('video') as HTMLVideoElement;
      if (videoElement && (videoElement as any).webkitExitFullscreen) {
        (videoElement as any).webkitExitFullscreen();
        return true;
      }
    }

    // Standard exit fullscreen implementation
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    }
    return true;
  } catch (error) {
    console.error("Error exiting fullscreen mode:", error);
    return false;
  }
}

export function isFullscreen(): boolean {
  // For iOS, check if video is in fullscreen mode
  if (isIOS()) {
    const videoElement = document.querySelector('video') as HTMLVideoElement;
    if (videoElement && (videoElement as any).webkitDisplayingFullscreen) {
      return (videoElement as any).webkitDisplayingFullscreen;
    }
  }

  // Standard fullscreen detection
  return !!(
    document.fullscreenElement ||
    (document as any).webkitFullscreenElement ||
    (document as any).mozFullScreenElement ||
    (document as any).msFullscreenElement
  );
}
